exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n\n.tpgo_textfield_short{\n\twidth:130px !important;\n}\n\n.tpgo_textfield input{\n\t/*color:green !important;*/\n\tbackground-image: url(\"/img/risk-reward.jpg\");\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss"}!./src/css/material_ui_custom.css
// module id = 249
// module chunks = 0